export class CopyToClipboard {
    constructor (clipboardElement) {
        if (!clipboardElement) return;
        this.clipboardElement = clipboardElement;
        this.clipboardTooltip = document.querySelector('.js-copy-to-clipboard-tooltip');
        this.resetTimeout = null;

        this.addEventListeners();
    }

    addEventListeners () {
        this.clipboardElement.addEventListener('click', () => {
            this.clipboardTooltip.classList.remove('hidden');
            navigator.clipboard.writeText(window.location.href);

            if (this.resetTimeout) {
                clearTimeout(this.resetTimeout);
            }

            this.resetTimeout = setTimeout(() => {
                this.clipboardTooltip.classList.add('hidden');
            }, 3000);
        })
    }
}
